import { IconButton } from "@mui/material";
import { AddButton } from "app/components/Button/AddButton";
import { FilterSelect } from "app/components/FilterSelect";
import { ThreedotIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  selectRegistrationAxlesMeasureFilter,
  selectRegistrationBodyTypeFilter,
  selectRegistrationDhTypeFilter,
  selectRegistrationDriverCabinFilter,
  selectRegistrationFrontLoadFilter,
  selectRegistrationRearAxlesMeasureFilter,
  selectRegistrationTireFilter,
  selectRegistrationWeightFilter,
} from "../../redux/selector";
import { registrationActions } from "../../redux/slice";
import { RegistrationFilterValue } from "../../types";
import { useStyles } from "./styles";

type Props = {
  onAddClick?: () => void;
};

const FILTER_OPTIONS: RegistrationFilterValue[] = ["ALL"];

const ActionBar = ({ onAddClick }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  const driverCabinFilter = useSelector(selectRegistrationDriverCabinFilter);
  const axlesMeasureFilter = useSelector(selectRegistrationAxlesMeasureFilter);
  const frontLoadFilter = useSelector(selectRegistrationFrontLoadFilter);
  const rearAxlesMeasureFilter = useSelector(
    selectRegistrationRearAxlesMeasureFilter
  );
  const weightFilter = useSelector(selectRegistrationWeightFilter);
  const tireFilter = useSelector(selectRegistrationTireFilter);
  const dhTypeFilter = useSelector(selectRegistrationDhTypeFilter);
  const bodyTypeFilter = useSelector(selectRegistrationBodyTypeFilter);

  const getAllLabel = () => t("REGISTRATION.FILTERS.ALL");

  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.actions}>
        <AddButton
          label={t("REGISTRATION.ACTIONS.ADD")}
          onClick={onAddClick}
        />
        <IconButton size="small" className={styles.iconButton}>
          <ThreedotIcon />
        </IconButton>
      </div>

      <div className={styles.filters}>
        <FilterSelect
          label={t("REGISTRATION.FILTERS.DRIVER_CABIN.LABEL")}
          value={driverCabinFilter}
          options={FILTER_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(registrationActions.setDriverCabinFilter(value))
          }
        />
        <FilterSelect
          label={t("REGISTRATION.FILTERS.AXLES_MEASURE.LABEL")}
          value={axlesMeasureFilter}
          options={FILTER_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(registrationActions.setAxlesMeasureFilter(value))
          }
        />
        <FilterSelect
          label={t("REGISTRATION.FILTERS.FRONT_LOAD.LABEL")}
          value={frontLoadFilter}
          options={FILTER_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(registrationActions.setFrontLoadFilter(value))
          }
        />
        <FilterSelect
          label={t("REGISTRATION.FILTERS.REAR_AXLES_MEASURE.LABEL")}
          value={rearAxlesMeasureFilter}
          options={FILTER_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(registrationActions.setRearAxlesMeasureFilter(value))
          }
        />
        <FilterSelect
          label={t("REGISTRATION.FILTERS.WEIGHT.LABEL")}
          value={weightFilter}
          options={FILTER_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(registrationActions.setWeightFilter(value))
          }
        />
        <FilterSelect
          label={t("REGISTRATION.FILTERS.TIRE.LABEL")}
          value={tireFilter}
          options={FILTER_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(registrationActions.setTireFilter(value))
          }
        />
        <FilterSelect
          label={t("REGISTRATION.FILTERS.DH_TYPE.LABEL")}
          value={dhTypeFilter}
          options={FILTER_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(registrationActions.setDhTypeFilter(value))
          }
        />
        <FilterSelect
          label={t("REGISTRATION.FILTERS.BODY_TYPE.LABEL")}
          value={bodyTypeFilter}
          options={FILTER_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(registrationActions.setBodyTypeFilter(value))
          }
        />
      </div>
    </div>
  );
};

export default ActionBar;
